import { render, staticRenderFns } from "./CrrnfdShipmentListModal.vue?vue&type=template&id=04a21149&scoped=true&"
import script from "./CrrnfdShipmentListModal.vue?vue&type=script&lang=ts&"
export * from "./CrrnfdShipmentListModal.vue?vue&type=script&lang=ts&"
import style0 from "./CrrnfdShipmentListModal.vue?vue&type=style&index=0&id=04a21149&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a21149",
  null
  
)

export default component.exports